import { Component } from "react";
import Popup from "..";
import AppContext from "../../../contexts/AppContext";
import RectButton from "../../ui/button/RectButton";
import Input from "../../ui/Input";
import CardSavedPopup from "../CardSavedPopup";

class SaveCardPopup extends Component {
    static contextType = AppContext;
    render() {
        return (
            <Popup className="save-card-popup slim">
                <h3>Name Your Card</h3>
                <div className="column">
                    <p>What would you like to name your masterpiece?</p>
                    <Input placeHolder="" />
                    <RectButton text="SAVE" onClick={()=>this.context.setPopup(<CardSavedPopup />)} />
                </div>
            </Popup>
        )
    }
}

export default SaveCardPopup;